import { axiosInstance } from "../../../axios/axiosInstance";

const API_SERVICE_PROVIDER_DASHBOARD_URL = "organization/dashboard";
const API_SERVICE_PROVIDER_DASHBOARD_INDEX_MODULE_LIST_URL = API_SERVICE_PROVIDER_DASHBOARD_URL + "/index";
const API_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_MODULE_LIST_URL = API_SERVICE_PROVIDER_DASHBOARD_URL + "/orders-matrics";
const API_SERVICE_PROVIDER_DASHBOARD_SALES_METRICS_MODULE_LIST_URL = API_SERVICE_PROVIDER_DASHBOARD_URL + "/sales-matrics";

export const getServiceProviderDashboardIndex = () => {
  return axiosInstance.get(API_SERVICE_PROVIDER_DASHBOARD_INDEX_MODULE_LIST_URL);
};

export const getServiceProviderDashboardOrderMetrics = () => {
  return axiosInstance.get(API_SERVICE_PROVIDER_DASHBOARD_ORDER_METRICS_MODULE_LIST_URL);
};

export const getServiceProviderDashboardSalesMetrics = () => {
  return axiosInstance.get(API_SERVICE_PROVIDER_DASHBOARD_SALES_METRICS_MODULE_LIST_URL);
};
